import React from 'react';
import './DashboardPages.css';

const Analytics = () => {
  return (
    <div className="page-container">
      <h2 className="page-title">Analytics</h2>

      <div className="analytics-grid">
        <div className="analytics-card">
          <h3>Page Views</h3>
          <p className="analytics-value">12,345</p>
          <span className="analytics-change positive">+12% from last month</span>
        </div>

        <div className="analytics-card">
          <h3>Unique Visitors</h3>
          <p className="analytics-value">8,901</p>
          <span className="analytics-change positive">+8% from last month</span>
        </div>

        <div className="analytics-card">
          <h3>Bounce Rate</h3>
          <p className="analytics-value">45.2%</p>
          <span className="analytics-change negative">-3% from last month</span>
        </div>

        <div className="analytics-card">
          <h3>Avg. Session Duration</h3>
          <p className="analytics-value">3:24</p>
          <span className="analytics-change positive">+15% from last month</span>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
